<template>
    <div class="chart-room">
        <transition name="chart">
            <div v-if="isMin" :key="1" class="mini-chart" @click="changeSmall"></div>
        </transition>
        <transition name="chart">
            <div v-show="!isMin" :key="2" class="big-chart">
                <div class="chart-list">
                    <div class="list-search fw-b f-14">
                        聊天信息
                        <!--<el-input size="mini" class="search-input" placeholder="搜索"
                                  prefix-icon="el-icon-search"></el-input>-->
                    </div>
                        <template v-for="(item,key,index) in chartData">
                            <ChartUserItem v-if="key"
                                           :other_id="other_id"
                                           @selectUser="selectUser($event, item)"
                                           :keys="key"
                                           :key="item.id"
                                           :item="item"></ChartUserItem>
                        </template>
                </div>
                <div class="chart-content">
                    <div class="content-top">
                        <div class="top-name">{{currentName}}</div>
                        <i class="el-icon-minus cur-p" @click="isMin=true"></i>
                        <!--<i class="el-icon-close cur-p"></i>-->
                    </div>
                    <div class="chart-body">
                        <ChartItem v-for="(item,index) in msgList" :key="index"
                                   :item="item"
                                   :head="userInfo.detail.portrait"
                                   :is-me="userInfo.detail.user_id==item.user_name"></ChartItem>
                        <div id="chartScorll"></div>
                    </div>
                    <label v-if="other_id" class="chart-bottom">
                        <textarea v-model="msg" class="chart-input" @keydown.enter="sendMsg" placeholder="请输入内容"></textarea>
                    </label>
                    <div v-if="other_id" class="btn-content">
                        <div  class="btn-item" @click="sendMsg">发送（Enter）</div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import ChartItem from "./ChartItem";
    import ChartUserItem from "./ChartUserItem";

    export default {
        name: "ChartRoom",
        components: {ChartItem, ChartUserItem},
        data() {
            return {
                isMin: true,
                msg: '',
                other_id: '',
                currentName: ''
            }
        },
        computed: {
            ...mapState(['userInfo', 'chartData']),
            msgList() {
                if (this.other_id) {
                    return this.chartData[this.other_id].content || this.chartData[this.other_id].msg
                }
                return []
            }
        },
        created() {
            this.$ws.on('chat message from server', this.handlerMsg)
            this.$eventBus.$on('openChart', this.openChart)
            this.socketSelect();
        },
        beforeDestroy() {
            this.$ws.off('chat message from server', this.handlerMsg)
            this.$eventBus.$off('openChart', this.openChart)
        },
        methods: {
            changeSmall(){
                this.isMin = false;
                this.$nextTick(() => {
                    chartScorll.scrollIntoView();
                })
            },
            selectUser(userInfo, item) {
                this.other_id = item.id;
                this.currentName = userInfo.name;
                this.$store.commit('unReadDel', item.id)
                this.$nextTick(() => {
                    chartScorll.scrollIntoView();
                })
            },
            openChart({id, name}){
                this.isMin = false;
                this.other_id = id;
                this.currentName = name;
                this.$store.commit('unReadDel', id)
                this.$nextTick(() => {
                    chartScorll.scrollIntoView();
                })
            },
            handlerMsg(data) {
                let msg = JSON.parse(data)
                let id = '';
                let info = '';
                if (this.userInfo.detail.user_id === msg.user) {
                    id = msg.name
                } else {
                    id = msg.user
                    info = msg.info
                }
                this.$store.commit('upDateChartData', {id, msg, info})
                if(id!=this.other_id){
                    this.$store.commit('unReadChart', id)
                }

                this.$nextTick(() => {
                    chartScorll.scrollIntoView();
                    this.$forceUpdate();
                })
            },
            sendMsg() {
                if(!this.msg){
                    return this.$message.warning('请输入内容')
                }
                let date = this.$dateFormat('yyyy/MM/dd hh:mm:ss');
                let msgs = {
                    user: this.userInfo.detail.user_id,
                    user_name: this.userInfo.detail.user_id,
                    avar: this.userInfo.detail.portrait,
                    stime: date,
                    created_at: date,
                    msg: this.msg,
                    content: this.msg,
                    info: {
                        nickname: this.userInfo.detail.nickname,
                        avar: this.userInfo.detail.portrait,
                    },
                    name: this.other_id
                };
                this.landlordMsgSendSave(this.userInfo.detail.user_id, this.other_id, this.msg);
                this.$ws.emit('chat message', JSON.stringify(msgs));
                this.msg = '';
            },
            async landlordMsgSendSave(user_id, user_id_two, content){
                let [e, data] = await this.$api.landlordMsgSendSaveApi({user_id, user_id_two, content})
            },
            async socketSelect(){
                let [e, data] = await this.$api.socketSelectApi();
                let object = data.result.reverse().reduce((obj, item)=>{
                    let id = '';
                    let info = '';
                    if (this.userInfo.detail.user_id === item.user_name) {
                        id = item.other_name
                    } else {
                        id = item.user_name;
                        info = {
                            avar: item.avar || 102,
                            nickname: id
                        }
                    }
                    if(!obj[id]){
                        obj[id] = {};
                        obj[id].id = id;
                        obj[id].num = 0;
                        obj[id].info = info;
                        obj[id].msg = [];
                    }
                    return obj
                }, {})
                this.$store.commit('setChartDate', object)
            },
        },
    }
</script>

<style scoped lang="less">
    .chart-room {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 99;

        .mini-chart {
            width: 80px;
            height: 80px;
            border-radius: 100%;
            background: url("./../assets/img/minichart.jpg") 100% 100% no-repeat;
            background-size: cover;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
            cursor: pointer;
            position: absolute;
            bottom: 0;
            right: 0;
            transform-origin: 50% 50%;
        }

        .big-chart {
            width: 700px;
            height: 500px;
            background-color: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
            display: flex;
            justify-content: flex-start;
            align-content: stretch;
            position: absolute;
            bottom: 0;
            right: 0;
            transform-origin: calc(~'100% - 40px') calc(~'100% - 40px');

            .chart-list {
                width: 200px;
                height: 100%;
                border-right: 1px solid #e2e2e2;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                    border-radius: 10px;
                    background-color: #EFF2F7;
                    cursor: pointer;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    background-color: rgba(228, 70, 70, 0.5);
                }

                &::-webkit-scrollbar {
                    background-color: #F5F5F5;
                }
            }

            .chart-content {
                flex: 1;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-flow: column;
            }

            .content-top {
                width: 100%;
                height: 60px;
                border-bottom: 1px solid #e2e2e2;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 0 20px;
                box-sizing: border-box;

                .top-name {
                    font-size: 18px;
                    font-weight: bold;
                    margin-right: auto;
                }

                .el-icon-minus, .el-icon-close {
                    margin-left: 10px;
                    font-size: 20px;

                    &:hover {
                        color: #e44646;
                    }
                }
            }

            .chart-bottom {
                width: 100%;
                height: 80px;
                border-top: 1px solid #e2e2e2;

                .chart-input {
                    width: 100%;
                    height: 100%;
                    resize: none;
                    border: none;
                    outline: none;
                    padding: 20px;
                    font-size: 14px;
                    box-sizing: border-box;

                    &::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                        border-radius: 10px;
                        background-color: #EFF2F7;
                        cursor: pointer;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background-color: rgba(228, 70, 70, 0.5);
                    }

                    &::-webkit-scrollbar {
                        background-color: #F5F5F5;
                    }
                }
            }

            .chart-body {
                flex: 1;
                width: 100%;
                padding: 16px;
                box-sizing: border-box;
                overflow-y: auto;
                background-color: #f8f8f8;

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                    border-radius: 10px;
                    background-color: #EFF2F7;
                    cursor: pointer;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    background-color: rgba(228, 70, 70, 0.5);
                }

                &::-webkit-scrollbar {
                    background-color: #F5F5F5;
                }
            }

            .btn-content {
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding: 0 20px;
                box-sizing: border-box;

                .btn-item {
                    width: 80px;
                    height: 30px;
                    line-height: 30px;
                    background-color: #e44646;
                    border-radius: 6px;
                    text-align: center;
                    font-size: 14px;
                    color: #ffffff;
                    cursor: pointer;
                }
            }

            .list-search {
                padding: 20px;
                width: 100%;
                box-sizing: border-box;
                position: sticky;
                text-align: center;
                top: 0;
                left: 0;
                z-index: 1;
                background-color: #ffffff;
            }

            .search-input {
                width: 100%;
            }

            .user-item {
                width: 100%;
                height: 60px;
                padding: 0 20px;
                display: flex;
                box-sizing: border-box;
                justify-content: flex-start;
                align-items: center;
                border-top: 1px solid #e2e2e2;
                cursor: pointer;

                &:hover {
                    background-color: #f2f2f2;
                    color: rgba(228, 70, 70, 0.99);
                }

                .user-head {
                    width: 30px;
                    height: 30px;
                    object-fit: cover;
                    border-radius: 100%;
                    margin-right: 10px;
                }

                .user-name {
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .active {
                background-color: #f2f2f2 !important;
                color: #e44646 !important;
                font-weight: bold;
            }
        }
    }
</style>
